import { Component, input, output } from '@angular/core';
import { TooltipDirective, TooltipPosition } from '../../../../core/directives/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { NgClass } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-general-icon-button',
  imports: [MatIconModule, NgClass, TranslatePipe, TooltipDirective],
  templateUrl: './general-icon-button.component.html',
  styleUrl: './general-icon-button.component.scss',
})
export class GeneralIconButtonComponent {
  readonly buttonIcon = input.required<string>();
  readonly buttonSize = input<16 | 24 | 32 | 40>(32);
  readonly iconSize = input<number>(32);
  readonly buttonStyle = input.required<'primary' | 'secondary' | 'inline'>();

  readonly buttonTooltip = input<string>();
  readonly buttonTooltipPosition = input<TooltipPosition>(TooltipPosition.BELOW);

  readonly disabled = input<boolean>(false);

  readonly buttonClicked = output<MouseEvent>();
}
